export default __webpack_public_path__ + "static/media/528.23cf3bdb.png";